


















import { Component, Vue, Prop } from 'vue-property-decorator'
import Collocation from '../../comps/collocation.vue'
import { env } from '@ivy/fts/envInfo/envInfo'
import TitleBar from '../comps/TitleBar.vue'
@Component({
  components: {
    Collocation,
    TitleBar,
  },
})
export default class CouponListPopup extends Vue {
  collocationList: any[] = []
  navbarHeight: number = 0 // app状态栏高度
  beforeCreate() {
    document.title = '搭配购列表'
  }

  get showTitleBar() {
    return env.type === 'ivydad' && this.$route.query.f_r_o_m === 'goodsView'
  }

  async created() {
    await env.init()
    this.navbarHeight = (await env.getNavbarHeight()) || 25
    await this.init()
  }

  async init() {
    let skuIds = this.$route.query.skuId
    if (!skuIds) return this.$Toast('参数错误')
    if (typeof skuIds === 'string') {
      skuIds = [skuIds]
    }
    let params = null
    if (this.$route.query.is_preview) {
      params = {
        skuId: this.$route.query.skuId,
        is_preview: 1,
      }
    } else {
      params = {
        skuId: this.$route.query.skuId,
      }
    }
    let { data: collocationList } = await this.$axios.get(
      '/api/goods/shop/search/collocation/getCollocationListIter',
      {
        params,
      }
    )
    this.collocationList = collocationList.sort((a, b) => {
      return b.id - a.id
    })
  }
  toDetail(id) {
    let query = this.$route.query
    this.$router.push({
      path: '/goodsSalesDetail',
      query: {
        cid: id,
        channel_id: query.channel_id,
        skuId: query.curSku,
        f_r_o_m: query.f_r_o_m,
      },
    })
  }
}
